import type { SVGProps } from 'react'

export function PieChart(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2M12 22V12M12 2V12M12 12L20.3333 6.44444"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}
